module.exports = __webpack_public_path__ + "static/media/hero-online-2.6b3898c0.png";